"use client";

import { useTranslation } from "react-i18next";
import { parseMarkdown } from "shared/utils";

export default function PartnerDescription({
  partner,
  type,
}: {
  partner: any;
  type: "pitch" | "about" | "how_we_help";
}) {
  const { t } = useTranslation();
  const { pitchTitle = "", pitchText = "", about = "", help = "" } = partner;

  const types = {
    about: {
      title: t("about"),
      text: about,
    },
    pitch: {
      title: pitchTitle,
      text: pitchText,
    },
    how_we_help: {
      title: t("how_we_help"),
      text: help,
    },
  };

  return (
    <div className="flex flex-col gap-4">
      <h4 className="p-0 m-0 text-lg font-normal text-[#1f384c]">
        {types[type]?.title}
      </h4>
      <div
        className="text-[#53565a] text-base font-thin leading-7 whitespace-pre-line break-words inline-block text-left"
        dangerouslySetInnerHTML={{ __html: parseMarkdown(types[type]?.text) }}
      />
    </div>
  );
}
